import { AssetType } from '@/shared/api/protocol-ts/model/dto_asset_pb';
import { Report_CBCT_IOS_Superimposition_Orientation } from '@/shared/api/protocol-ts/model/dto_report_type_cbct_ios_superimposition_pb';
import { StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';
import { OrderReportType, UploadStudyType } from '@/shared/config';

import { OrderReportModalStep } from './types';

export const UPLOAD_STUDY_FORM_ID = 'upload-study-form';

export const MAX_BYTES_FOR_STUDIES = 262144000; // 250MB
export const MAX_BYTES_FOR_CBCT = 10737418240; // 10GB

export const ORDER_REPORT_STUDY_TYPE: Record<OrderReportType, StudyType> = {
  CBCT: StudyType.StudyType_CBCT,
  Pano: StudyType.StudyType_PanoramicXRay,
  IOXRay: StudyType.StudyType_IntraoralXRay,
  '3DStudio': StudyType.StudyType_CBCT,
  ImplantStudio: StudyType.StudyType_CBCT,
  OrthoStudio: StudyType.StudyType_CBCT,
  IOSSegmentation: StudyType.StudyType_IOS_Meshes,
  RawMeshViewer: StudyType.StudyType_IOS_Meshes,
  Transcriptor: StudyType.StudyType_CBCT, // Using CBCT as placeholder for now
};

export const ORDER_REPORT_ASSET_TYPE: Record<OrderReportType, UploadStudyType> =
  {
    CBCT: AssetType.AssetType_Study_CBCT,
    Pano: AssetType.AssetType_Study_PanoramicXRay,
    IOXRay: AssetType.AssetType_Study_IntraoralXRay,
    '3DStudio': AssetType.AssetType_Study_CBCT,
    ImplantStudio: AssetType.AssetType_Study_CBCT,
    OrthoStudio: AssetType.AssetType_Study_CBCT,
    IOSSegmentation: AssetType.AssetType_Study_IOS_Meshes,
    RawMeshViewer: AssetType.AssetType_Study_IOS_Meshes,
    Transcriptor: AssetType.AssetType_Study_CBCT, // Using CBCT as placeholder for now
  };

export const SELECT_INPUT_NAME: Record<
  OrderReportModalStep,
  'mainStudyID' | 'IOSMeshesStudyID' | 'SecondaryCBCTStudyID'
> = {
  '1': 'mainStudyID',
  '2': 'IOSMeshesStudyID',
  '3': 'SecondaryCBCTStudyID',
};

export const SUPERIMPOSITION_ORIENTATION_OPTIONS: Report_CBCT_IOS_Superimposition_Orientation[] =
  [
    Report_CBCT_IOS_Superimposition_Orientation.CBCT_IOS_Superimposition_Orientation_CBCT,
    Report_CBCT_IOS_Superimposition_Orientation.CBCT_IOS_Superimposition_Orientation_IOS,
    Report_CBCT_IOS_Superimposition_Orientation.CBCT_IOS_Superimposition_Orientation_Zero_index,
  ];
